import ordersActionTypes from './action-types';

export const fetchAllOrders = payload => ({
  type: ordersActionTypes.FETCH_ALL_ORDERS,
  payload,
});

export const fetchAllOrdersSuccess = payload => ({
  type: ordersActionTypes.FETCH_ALL_ORDERS_SUCCESS,
  payload,
});

export const fetchAllOrdersFail = payload => ({
  type: ordersActionTypes.FETCH_ALL_ORDERS_FAIL,
  payload,
});

export const setAllOrdersAssignedEntityDetails = payload => ({
  type: ordersActionTypes.SET_ALL_ORDERS_ASSIGNED_ENTITY_DETAILS,
  payload,
});

export const fetchOrderDetails = payload => ({
  type: ordersActionTypes.FETCH_ORDER_DETAILS,
  payload,
});

export const fetchOrderDetailsSuccess = payload => ({
  type: ordersActionTypes.FETCH_ORDER_DETAILS_SUCCESS,
  payload,
});

export const fetchOrderDetailsFail = payload => ({
  type: ordersActionTypes.FETCH_ORDER_DETAILS_FAIL,
  payload,
});

export const setOrderPatientUserDetails = payload => ({
  type: ordersActionTypes.SET_ORDER_PATIENT_USER_DETAILS,
  payload,
});

export const setOrderAssignedEntityDetails = payload => ({
  type: ordersActionTypes.SET_ORDER_ASSIGNED_ENTITY_DETAILS,
  payload,
});

export const setOrderLogsDetails = payload => ({
  type: ordersActionTypes.SET_ORDER_LOGS_DETAILS,
  payload,
});

export const setOrderServicesDetails = payload => ({
  type: ordersActionTypes.SET_ORDER_SERVICES_DETAILS,
  payload,
});

export const setOrderDispensedItemsDetails = payload => ({
  type: ordersActionTypes.SET_ORDER_DISPENSED_ITEMS_DETAILS,
  payload,
});

export const setOrderResults = payload => ({
  type: ordersActionTypes.SET_ORDER_RESULTS,
  payload,
});

export const fetchAssignOrderToEntity = payload => ({
  type: ordersActionTypes.FETCH_ASSIGN_ORDER_TO_ENTITY,
  payload,
});

export const fetchAssignOrderToEntitySuccess = payload => ({
  type: ordersActionTypes.FETCH_ASSIGN_ORDER_TO_ENTITY_SUCCESS,
  payload,
});

export const fetchAssignOrderToEntityFail = payload => ({
  type: ordersActionTypes.FETCH_ASSIGN_ORDER_TO_ENTITY_FAIL,
  payload,
});

export const fetchOrderServicesSuggestions = payload => ({
  type: ordersActionTypes.FETCH_ORDER_SERVICES_SUGGESTIONS,
  payload,
});

export const fetchOrderServicesSuggestionsSuccess = payload => ({
  type: ordersActionTypes.FETCH_ORDER_SERVICES_SUGGESTIONS_SUCCESS,
  payload,
});

export const fetchOrderServicesSuggestionsFail = () => ({
  type: ordersActionTypes.FETCH_ORDER_SERVICES_SUGGESTIONS_FAIL,
});

export const resetOrderServicesSuggestions = () => ({
  type: ordersActionTypes.RESET_ORDER_SERVICES_SUGGESTIONS,
});

export const fetchOrderServicesSubmission = payload => ({
  type: ordersActionTypes.FETCH_ORDER_SERVICES_SUBMISSION,
  payload,
});

export const fetchOrderServicesSubmissionSuccess = () => ({
  type: ordersActionTypes.FETCH_ORDER_SERVICES_SUBMISSION_SUCCESS,
});

export const fetchOrderServicesSubmissionFail = () => ({
  type: ordersActionTypes.FETCH_ORDER_SERVICES_SUBMISSION_FAIL,
});

export const fetchOrderStatusChangeSubmission = payload => ({
  type: ordersActionTypes.FETCH_ORDER_STATUS_CHANGE_SUBMISSION,
  payload,
});

export const fetchOrderStatusChangeSubmissionSuccess = () => ({
  type: ordersActionTypes.FETCH_ORDER_STATUS_CHANGE_SUBMISSION_SUCCESS,
});

export const fetchOrderStatusChangeSubmissionFail = () => ({
  type: ordersActionTypes.FETCH_ORDER_STATUS_CHANGE_SUBMISSION_FAIL,
});

export const fetchOrderNoteChangeSubmission = payload => ({
  type: ordersActionTypes.FETCH_ORDER_NOTE_CHANGE_SUBMISSION,
  payload,
});

export const fetchOrderNoteChangeSubmissionSuccess = () => ({
  type: ordersActionTypes.FETCH_ORDER_NOTE_CHANGE_SUBMISSION_SUCCESS,
});

export const fetchOrderNoteChangeSubmissionFail = () => ({
  type: ordersActionTypes.FETCH_ORDER_NOTE_CHANGE_SUBMISSION_FAIL,
});

export const fetchScheduleOrderSubmission = payload => ({
  type: ordersActionTypes.FETCH_SCHEDULE_ORDER_SUBMISSION,
  payload,
});

export const fetchScheduleOrderSubmissionSuccess = () => ({
  type: ordersActionTypes.FETCH_SCHEDULE_ORDER_SUBMISSION_SUCCESS,
});

export const fetchScheduleOrderSubmissionFail = () => ({
  type: ordersActionTypes.FETCH_SCHEDULE_ORDER_SUBMISSION_FAIL,
});

export const fetchScheduleOrderReasons = () => ({
  type: ordersActionTypes.FETCH_SCHEDULE_ORDER_REASONS,
});

export const fetchScheduleOrderReasonsSuccess = payload => ({
  type: ordersActionTypes.FETCH_SCHEDULE_ORDER_REASONS_SUCCESS,
  payload,
});

export const fetchScheduleOrderReasonsFail = () => ({
  type: ordersActionTypes.FETCH_SCHEDULE_ORDER_REASONS_FAIL,
});

export const fetchCancelOrderReasons = () => ({
  type: ordersActionTypes.FETCH_CANCEL_ORDER_REASONS,
});

export const fetchCancelOrderReasonsSuccess = payload => ({
  type: ordersActionTypes.FETCH_CANCEL_ORDER_REASONS_SUCCESS,
  payload,
});

export const fetchCancelOrderReasonsFail = () => ({
  type: ordersActionTypes.FETCH_CANCEL_ORDER_REASONS_FAIL,
});
